export const sideNavWidth = 240;
export const sideNavWidthCollapsed = 60;
export const desktopMediaQueryWidth = '(min-width: 720px)';
export const collapseButtonSize = 30;
export const hoverColor = '#f2f2f2';
